import CommonError from '@/common/utils/errors/CommonError';

export default class ClusterNotFoundError extends CommonError {
  constructor() {
    super('Error while getting a storage cluster', 'Cluster not found');
  }
}
